// extracted by mini-css-extract-plugin
export default {"card":"Card_card__DFRpu","cardHeader":"Card_cardHeader__+Ncfw","cardBody":"Card_cardBody__T0yxW"};